import React, { Component } from "react";

import { Route, Switch, BrowserRouter } from "react-router-dom";

import Home from "../pages/home/HomeComponent";
import Splash from "../pages/splash/Splash";
import Education from "../pages/education/EducationComponent";
import Experience from "../pages/experience/Experience";
import Contact from "../pages/contact/ContactComponent";
import Publications from "../pages/publications/Publications";
import Projects from "../pages/projects/Projects";

import WeddingInvitation from "../pages/invitation/WeddingInvitation";

import { settings } from "../portfolio.js";

import Error404 from "../pages/errors/error404/Error";

import ScrollToTop from "../components/ScrollToTop";
import Analytics from "../components/Analytics";

export default class Main extends Component {
  render() {
    return (
      <BrowserRouter basename="/">
        {/* Google Analytics listens to this same router */}
        <Analytics />

        <ScrollToTop>
          <Switch>
            <Route
              path="/"
              exact
              render={(props) =>
                settings.isSplash ? (
                  <Splash {...props} theme={this.props.theme} />
                ) : (
                  <Home {...props} theme={this.props.theme} />
                )
              }
            />

            <Route
              path="/home"
              exact
              render={(props) => <Home {...props} theme={this.props.theme} />}
            />

            <Route
              path="/experience"
              exact
              render={(props) => (
                <Experience {...props} theme={this.props.theme} />
              )}
            />

            <Route
              path="/education"
              exact
              render={(props) => (
                <Education {...props} theme={this.props.theme} />
              )}
            />

            <Route
              path="/publications"
              exact
              render={(props) => (
                <Publications {...props} theme={this.props.theme} />
              )}
            />

            <Route
              path="/contact"
              exact
              render={(props) => (
                <Contact {...props} theme={this.props.theme} />
              )}
            />

            <Route
              path="/projects"
              exact
              render={(props) => (
                <Projects {...props} theme={this.props.theme} />
              )}
            />

            {/* Hidden wedding invitation page.
                No navigation link points to this route. */}
            <Route path="/invitation" exact component={WeddingInvitation} />

            {settings.isSplash && (
              <Route
                path="/splash"
                render={(props) => (
                  <Splash {...props} theme={this.props.theme} />
                )}
              />
            )}

            <Route
              path="*"
              render={(props) => (
                <Error404 {...props} theme={this.props.theme} />
              )}
            />
          </Switch>
        </ScrollToTop>
      </BrowserRouter>
    );
  }
}
